import { Card, Statistic } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import type { DashboardWidget } from '@/api/dashboardApi';

interface MetricCardProps {
  widget: DashboardWidget;
  data?: {
    value: number;
    prefix?: string;
    suffix?: string;
    trend?: number;
    precision?: number;
  };
  loading?: boolean;
}

export default function MetricCard({ widget, data, loading }: MetricCardProps) {
  const value = data?.value ?? 0;
  const trend = data?.trend;
  const precision = data?.precision ?? 0;

  return (
    <Card size="small" loading={loading} style={{ height: '100%' }}>
      <Statistic
        title={widget.title}
        value={value.toFixed(precision)}
        prefix={data?.prefix}
        suffix={
          <>
            {data?.suffix}
            {trend !== undefined && trend !== 0 && (
              <span style={{ fontSize: 14, marginLeft: 8, color: trend > 0 ? '#3f8600' : '#cf1322' }}>
                {trend > 0 ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
                {Math.abs(trend)}%
              </span>
            )}
          </>
        }
      />
    </Card>
  );
}
